import { render } from "./List.vue?vue&type=template&id=64bc89e0&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=64bc89e0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-64bc89e0"

export default script